export default __webpack_public_path__ + "static/media/V-Ray Showreel 2017.23ea87f7.mp3";